window.isOnline = function() {
    if (window.navigator.onLine) {
        setOnline();
    } else {
        setOffline();
    }
};

window.setOffline = function() {
    $('.alert-offline').show();
    $('.btn').each(function(k, button) {
        if (!$(button).is(":disabled")) {
            $(button)
                .attr('disabled', true)
                .addClass('button-offline');
        }
    });
};

window.setOnline = function() {
    $('.alert-offline').hide();
    $('.button-offline')
        .attr('disabled', false)
        .removeClass('button-offline');
};

window.checkOnline = async function() {
    if (environment === "local") {
        return false;
    }

    if (!window.navigator.onLine) {
        return false;
    }

    const url = new URL(window.location.origin);
    url.searchParams.set('ts', new Date().getTime());

    try {
        const response = await fetch(
            url.toString(),
            { method: 'HEAD' },
        );
        if (response.ok) {
            setOnline();
        } else {
            setOffline();
        }
    } catch {
        setOffline();
    }
}

window.addEventListener('offline', (e) => {
    setOffline();
});

window.addEventListener('online', (e) => {
    setOnline();
});

setInterval(checkOnline, 5000);
